import { render, staticRenderFns } from "./blockTime.vue?vue&type=template&id=74807b6c&scoped=true&"
import script from "./blockTime.vue?vue&type=script&lang=js&"
export * from "./blockTime.vue?vue&type=script&lang=js&"
import style0 from "./blockTime.vue?vue&type=style&index=0&id=74807b6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74807b6c",
  null
  
)

export default component.exports